import React from 'react'
import { Image } from 'react-bootstrap';
import sideMenuLogo from '../../images/ergusLogo.png'

const TaniTedaviSideMenu = ({ handleMenuItemClick, activeMenuItem }) => {
    return (
        <div className="menu d-flex justify-content-center align-items-center flex-column">
            <ul>
                <li onClick={() => handleMenuItemClick('Deri Hastalıklarının Tanı Ve Tedavisi')} className={activeMenuItem === 'Deri Hastalıklarının Tanı Ve Tedavisi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Deri Hastalıklarının Tanı Ve Tedavisi
                </li>
                <li onClick={() => handleMenuItemClick('Allerjik Hastalıklar Tanı Ve Tedavisi')} className={activeMenuItem === 'Allerjik Hastalıklar Tanı Ve Tedavisi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Allerjik Hastalıklar Tanı Ve Tedavisi
                </li>
                <li onClick={() => handleMenuItemClick('Alerji Testleri')} className={activeMenuItem === 'Alerji Testleri' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Alerji Testleri
                </li>
                <li onClick={() => handleMenuItemClick('Deri Biopsisi')} className={activeMenuItem === 'Deri Biopsisi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Deri Biopsisi
                </li>
                <li onClick={() => handleMenuItemClick('Elektro Koterizasyon')} className={activeMenuItem === 'Elektro Koterizasyon' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Elektro Koterizasyon
                </li>
                <li onClick={() => handleMenuItemClick('Kriyoterapi')} className={activeMenuItem === 'Kriyoterapi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Kriyoterapi
                </li>
                <li onClick={() => handleMenuItemClick('Küçük Cerrahi Girişimler')} className={activeMenuItem === 'Küçük Cerrahi Girişimler' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Küçük Cerrahi Girişimler
                </li>
                <li onClick={() => handleMenuItemClick('Mantar Hastalıkları Ve Tedavisi')} className={activeMenuItem === 'Mantar Hastalıkları Ve Tedavisi' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Mantar Hastalıkları Ve Tedavisi
                </li>
                <li onClick={() => handleMenuItemClick('Güneş Lekeleri Nedir, Korunma Ve Tedavi Yöntemleri Nelerdir?')} className={activeMenuItem === 'Güneş Lekeleri Nedir, Korunma Ve Tedavi Yöntemleri Nelerdir?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Güneş Lekeleri Nedir, Korunma Ve Tedavi Yöntemleri Nelerdir?
                </li>
                <li onClick={() => handleMenuItemClick('Kimyasal Peeling Nedir, Hangi Alanlarda Kullanılır?')} className={activeMenuItem === 'Kimyasal Peeling Nedir, Hangi Alanlarda Kullanılır?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Kimyasal Peeling Nedir, Hangi Alanlarda Kullanılır?
                </li>
                <li onClick={() => handleMenuItemClick('Botox Nedir, Hangi Amaçlarla Kullanılır?')} className={activeMenuItem === 'Botox Nedir, Hangi Amaçlarla Kullanılır?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Botox Nedir, Hangi Amaçlarla Kullanılır?
                </li>
                <li onClick={() => handleMenuItemClick('Dolgu Nedir, Niçin Uygulanır?')} className={activeMenuItem === 'Dolgu Nedir, Niçin Uygulanır?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Dolgu Nedir, Niçin Uygulanır?
                </li>
                <li onClick={() => handleMenuItemClick('Prp Nedir, Niçin Uygulanır?')} className={activeMenuItem === 'Prp Nedir, Niçin Uygulanır?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Prp Nedir, Niçin Uygulanır?
                </li>
                <li onClick={() => handleMenuItemClick('Mezoterapi Nedir, Nerelerde Kullanılır?')} className={activeMenuItem === 'Mezoterapi Nedir, Nerelerde Kullanılır?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Mezoterapi Nedir, Nerelerde Kullanılır?
                </li>
                <li onClick={() => handleMenuItemClick('Akne Vulgaris Nedir Ve Nasıl Oluşur?')} className={activeMenuItem === 'Akne Vulgaris Nedir Ve Nasıl Oluşur?' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Akne Vulgaris Nedir Ve Nasıl Oluşur?
                </li>
                <li onClick={() => handleMenuItemClick('Ürtiker (Kurdeşen)')} className={activeMenuItem === 'Ürtiker (Kurdeşen)' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Ürtiker (Kurdeşen)
                </li>
                <li onClick={() => handleMenuItemClick('Uçuk')} className={activeMenuItem === 'Uçuk' ? 'active' : ''}>
                    <Image src={sideMenuLogo} fluid className="menu-icon" />
                    Uçuk (Herpes Simplex), Zona, Gece Yanığı (Zona Zoster), Su Çiçeği (Varisella)
                </li>
            </ul>
        </div>
    );
};

export default TaniTedaviSideMenu;